let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("llATb")).then(() => parcelRequire('63C9h'));